module.exports = __webpack_public_path__ + "img/dollar-sign.66413808.svg";